import React, {useContext, useEffect, useMemo, useState} from 'react'
import ActivosList from '../../components/activosList/ActivosList.js';

import { useParams } from 'react-router-dom';

//Context
import authContext from '../../context/authentication/authContex';
import activosContext from '../../context/activoContex/activoContex.js';

import MapIcon from '@mui/icons-material/Map';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faPen, faSearch } from "@fortawesome/free-solid-svg-icons";

// Alertas
import Swal from 'sweetalert2'

//Styles
import './ActivosSupervisorView.css';
import SearchInput from '../../components/searchInput/SearchInput.js';
import procedimientoContext from '../../context/procedimientoContext/procedimientoContext.js';
import checklistContext from '../../context/checklistContext/checklistContext.js';
import SpatialTabActivos from '../../components/spatialTabActivos/SpatialTabActivos.js';
import ModalTuto from '../../components/modalTuto/ModalTuto.js';
import { FilterActivos } from '../../components/filtersActivos/FilterActivos.js';
import FilterScreen from '../../components/filterScreen/FilterScreen.js';

const ActivosSupervisorView = () =>{

    const {codActivo} = useParams();
    
    const acContext = useContext(activosContext);
    const {activoList, getFilesActivo, procsProgramadosList, docsXactivoList, getMantenimientosProgramados, getDocsXActivo, iniciarFiltros, filterActivos, filtros, setFiltros} = acContext;
    const [loading,setLoading] = useState(activoList != null ? false : true);

    const procContext = useContext(procedimientoContext);
    const {actualizarProcedimientoList} = procContext;

    const ckContext = useContext(checklistContext);
    const {actualizarChecklistList} = ckContext;

    const ahContext = useContext(authContext);
    const {showTuto, notShowTuto, checkIfOnlyRevisor} = ahContext;

    const [activosModelados,setActivosModelados] = useState(undefined);
    const [filter,setFilter] = useState(codActivo != undefined ? codActivo : '');
    const [activosToSee, setActivosToSee] = useState('all');
    const [view,setView] = useState('normal');
    const [editingTab,setEditingTab] = useState(false);
    
    //Necesario para filtro avanzado.
    const [showFilter,setShowFilter] = useState(false);

    const getData = async() =>{
        await getMantenimientosProgramados();
        await getDocsXActivo();
        await actualizarProcedimientoList();
        await actualizarChecklistList();
        
        //actualizaractivoList()
        //.then(res => setLoading(false));
    }

    const handleOnBlur =() =>{
        setTimeout(() => {
            window.scrollBy(0, 1); // Small scroll to refresh the view
        }, 100); // Delay to ensure keyboard is closed
    }
    
    const modelateActivos = async() =>{
        let aModelados = [];
        let porVencerDocs = 0;
        let vencidosDocs = 0;
        let porVencerProcs = 0;
        let vencidosProcs = 0;
        let porVencerProcsChecklist = 0;
        let vencidosProcsChecklist = 0;
        let porVencerProcsDirectos = 0;
        let vencidosProcsDirectos = 0;

        let activosFiltrados = filterActivos();

        for(const a of activosFiltrados){
            let aModelado = {...a};
            porVencerDocs = 0;
            vencidosDocs = 0;
            porVencerProcs = 0;
            vencidosProcs = 0;
            porVencerProcsChecklist = 0;
            vencidosProcsChecklist = 0;
            porVencerProcsDirectos = 0;
            vencidosProcsDirectos = 0;
            
            if(procsProgramadosList != undefined && procsProgramadosList.length > 0){
                let procsProgramadosByActivo = procsProgramadosList.filter(p => p.activoID == a._id);

                for(const p of procsProgramadosByActivo){
                    if (p.supervisorVisible){
                        if(p.state != 'COMPL'){
                            if(p.tipoAlerta == 'PorVENC'){
                                if(p.originado == 'CHECKLIST') porVencerProcsChecklist++;
                                else if(p.originado == 'DIRECTO') porVencerProcsDirectos++;
                                else porVencerProcs ++;
                            } else {
                                if(p.originado == 'CHECKLIST') vencidosProcsChecklist++;
                                else if(p.originado == 'DIRECTO') vencidosProcsDirectos++;
                                else vencidosProcs++;
                            } 
                        }
                    }
                }
            }
           
            aModelado = {
                ...aModelado,
                procsPorVencerCount: porVencerProcs,
                procsVencidosCount: vencidosProcs,
                docsPorVencerCount: porVencerDocs,
                docsVencidosCount: vencidosDocs,
                procsChecklistPorVencerCount: porVencerProcsChecklist,
                procsChecklistVencidosCount: vencidosProcsChecklist, 
                procsDirectosPorVencerCount: porVencerProcsDirectos, 
                procsDirectosVencidosCount: vencidosProcsDirectos, 
            }
            aModelados.push(aModelado);
        }
        setActivosModelados(aModelados);
    }

    useEffect(()=>{
        iniciarFiltros();
        getData();
    },[])

    useEffect(()=>{
        if(activoList != undefined && activoList != null && activoList.length > 0 ){
            setLoading(false);
            modelateActivos();
        }else if(activoList != null && activoList.length == 0){
            setLoading(false);
            setActivosModelados([]);
        }else if(activoList == null) {
        }
    },[activoList,filtros,procsProgramadosList,docsXactivoList])

    /*Evaluar de colocarlo en un contexto*/
    useEffect(() => {
        function handleResize() {
          console.log(`Height: ${window.innerHeight}`);
          console.log(`Width: ${window.innerWidth}`);
        }
    
        // Attach the event listener to the window object
        window.addEventListener('resize', handleResize);
    
        // Remove the event listener when the component unmounts
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    const activosFiltrados = useMemo(()=> {
        if(activosModelados){
            return activosModelados.filter(a =>(activosToSee == 'withAlert' ? (a.procsPorVencerCount > 0 || a.procsVencidosCount > 0 || a.docsPorVencerCount > 0 || a.docsVencidosCount>0 || a. procsChecklistPorVencerCount > 0 || a.procsChecklistVencidosCount > 0 || a.procsDirectosPorVencerCount > 0 || a.procsDirectosVencidosCount > 0) : (activosToSee == 'workingNow') ? (a.userWorking != undefined && a.userWorking != '') : true))
        }else return []
    },[activosModelados,activosToSee])

    return <div className='tabActivosView'>
        <div className="utilitiesDiv">
            <button className={`solapaBtn ${(activosToSee == 'all') ? 'selected' : ''} `} onClick={()=>setActivosToSee('all')} >Todos</button>
            <button className={`solapaBtn ${(activosToSee == 'withAlert') ? 'selected' : ''} `} onClick={()=>setActivosToSee('withAlert')} >Con Alerta</button>
            {!checkIfOnlyRevisor() && <button className={`solapaBtn ${(activosToSee == 'workingNow') ? 'selected' : ''} `} onClick={()=>setActivosToSee('workingNow')} >TAHO</button>}
            <FilterScreen verFiltro={setShowFilter}/>
            <SearchInput filter={filter} buscar={setFilter} handleOnBlur={handleOnBlur}/>
        </div>
        {(activosModelados == undefined || activosModelados == null || loading) ?
            <h3 className='warningStatusMsg'>
                Cargando<span>.</span><span>.</span><span>.</span>
            </h3> : 
            (activosModelados.length > 0) ? <ActivosList activos={activosFiltrados} filter={filter} componentePadre={'ActivosSupervisorView'}/> : <h3 className='warningStatusMsg'>No hay activos para mostrar</h3>
        }
        {showTuto && <ModalTuto notShowTuto={notShowTuto}/>}
        {showFilter && <FilterActivos setShowFilter={setShowFilter} filtros={filtros} setFiltros={setFiltros}/>}
    </div>

}

export default ActivosSupervisorView;